module.exports = __webpack_public_path__ + "static/brick-aa6a72a990a6a43969b9e80133a1c07a.jpg";